// extracted by mini-css-extract-plugin
export default {"categories_container":"categories_categories_container__Q8wYm","categories_content":"categories_categories_content__ucfDs"};